<template>
  <div
    class="bill bill_text_color--text"
    :style="{ backgroundImage: branch_watermark }"
  >
    <div
      style="width: 100%; margin-bottom: 8px"
      class="align-center justify-center row-reversable"
    >
      <div
        style="
          flex: 1;
          display: flex;
          font-size: 12px;
          flex-direction: column;
          justify-content: center;
        "
        class="align-start"
      >
        <img
          alt="SO"
          class="bill_logo"
          :src="branch_logo"
          style="width: 2cm; height: auto"
        />
      </div>
      <div style="display: flex; justify-content: center; align-items: center">
        <div class="font-weight-bold" style="text-align: center">
          <div class="font-weight-bold bill_title">{{ branch_fa_name }}</div>
          <div class="font-weight-bold bill_title">{{ LONG_APP_NAME }}</div>
          <div class="font-weight-bold bill_title">
            {{ $t("exchange_bill_title") }}
          </div>
        </div>
      </div>
      <div
        style="
          flex: 1;
          display: flex;
          font-size: 12px;
          flex-direction: column;
          justify-content: center;
        "
        class="align-end"
      >
        <span>
          <span class="pcf-label">{{ $t("tr") }}: </span>
          <span class="pcf-text">
            {{
              exchange.id || (system && system.last_form_number + 1)
            }}</span
          >
        </span>
        <span>
          <span class="pcf-label">{{ $t("date") }}: </span>
          <span class="pcf-text">{{ exchange.date }} {{ exchange.time }}</span>
        </span>
        <span>
          <span class="pcf-label">{{ $t("persian_date") }}: </span>
          <span class="pcf-text">{{
            exchange.date | persianDateFilter(true)
          }}
          </span>
        </span>
        <span>
          <span class="pcf-label">{{ $t("customer_type") }}: </span>
          <span class="pcf-text">{{
            exchange.customer && $t(exchange.customer.type)
          }}
          </span>
        </span>
      </div>
    </div>

    <table class="greyGridTable bill-table mb-5">
      <tbody class="lr--text">
        <tr>
          <td
            colspan="100%"
            class="bill_color white--text"
            style="font-size: 15px; font-weight: 500"
          >
            <span>
              {{ $t("customer_details") }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="pcf-label">{{ $t("reg_no") }}: </span>
            <span class="mx-2 pcf-text">{{ exchange.reg_id }}</span>
          </td>
          <td colspan="2">
            <span class="pcf-label">{{ $t("company") }}: </span>
            <span class="mx-2 pcf-text">{{ exchange.corporate_name }}</span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("full_name") }}: </span>
            <span class="mx-2 pcf-text">{{ exchange.name }}</span>
          </td>
          <td colspan="2">
            <span class="pcf-label">{{ $t("father_name") }}: </span>
            <span class="mx-2 pcf-text">{{ exchange.father_name }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span class="pcf-label">{{ $t(exchange.doctype) }}: </span>
            <span class="mx-2 pcf-text">{{ exchange.docno }}</span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("occupation") }}: </span>
            <span class="mx-2 pcf-text">{{ exchange.occupation }}</span>
          </td>
          <td colspan="3">
            <span class="pcf-label">{{ $t("nationality") }}: </span>
            <span class="mx-2 pcf-text">{{ exchange.nationality }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span class="pcf-label">{{ $t("place_of_birth") }}: </span>
            <span class="mx-2 pcf-text">{{ exchange.place_of_birth }}</span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("date_of_birth") }}: </span>
            <span class="mx-2 pcf-text">{{ exchange.date_of_birth }}</span>
          </td>
          <td colspan="3">
            <span class="pcf-label">{{ $t("source_of_fund") }}: </span>
            <span class="mx-2 pcf-text">{{ exchange.source_of_fund }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span class="pcf-label">{{ $t("phones") }}: </span>
            <span class="mx-2 pcf-text">{{ exchange.pretty_phones }}</span>
          </td>
          <td colspan="100%">
            <span class="pcf-label">{{ $t("purpose_of_transaction") }}: </span>
            <span class="mx-2 pcf-text">{{
              exchange.purpose_of_transaction
            }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="100%">
            <span class="pcf-label">{{ $t("address") }}: </span>
            <span class="mx-2 pcf-text">{{ exchange.address }}</span>
          </td>
        </tr>
        <tr>
          <td
            class="white"
            colspan="100%"
            style="padding-top: 5px; padding-bottom: 5px"
          ></td>
        </tr>
        <tr class="mt-2 text-xs-center">
          <td
            colspan="3"
            class="bill_color white--text text-xs-center"
            style="font-size: 15px; font-weight: 500"
          >
            <span>
              {{ $t("buy_currency_details") }}
            </span>
          </td>
          <td
            colspan="3"
            class="bill_color white--text text-xs-center"
            style="font-size: 15px; font-weight: 500"
          >
            <span>
              {{ $t("sale_currency_details") }}
            </span>
          </td>
        </tr>
        <tr class="mt-2">
           <td class="pcf-label" style="text-align: center !important">
            <span>
              {{ $t("id") }}
            </span>
          </td>
          <td class="pcf-label" style="text-align: center !important">
            <span>
              {{ $t("currency") }}
            </span>
          </td>
          <td class="pcf-label" style="text-align: center !important">
            <span>
              {{ $t("amount") }}
            </span>
          </td>
          <td class="pcf-label" style="text-align: center !important">
            <span>
              {{ $t("exchange_rate") }}
            </span>
          </td>
          <td class="pcf-label" style="text-align: center !important">
            <span>
              {{ $t("currency") }}
            </span>
          </td>
          <td class="pcf-label" style="text-align: center !important">
            <span>
              {{ $t("amount") }}
            </span>
          </td>
        </tr>
        <template v-for="(item, i) in exchange.items">
          <tr :key="`${i}_er`" style="text-align: center !important">
             <td>
              <span class="pcf-text capitalize">
                {{ item.id }}
              </span>
            </td>
            <td>
              <span class="pcf-text capitalize">
                {{ smbl(item.buy_currency_id, true) }}
              </span>
            </td>
            <td>
              <span class="pcf-text capitalize">
                {{ item.exchanged_amount | currency }}
              </span>
            </td>
            <td>
              <span class="pcf-text capitalize">
                {{ item.rate }}
              </span>
            </td>
            <td>
              <span class="pcf-text capitalize">
                {{ smbl(item.sale_currency_id, true) }}
              </span>
            </td>
            <td>
              <span class="pcf-text capitalize">
                {{ item.amount | currency }}
              </span>
            </td>
          </tr>
        </template>
        <tr
          :key="key"
          class="font-weight-bold"
          v-for="(value, key) in summery.currencies"
        >
          <td
            colspan="4"
            class="pcf-label capitalize"
            style="text-align: center !important"
          >
            {{ summery.amount[value] | toWord }}
            {{ smbl(value, isRTL) }}
          </td>
          <td
            class="pcf-label font-weight-bold"
            style="text-align: center !important"
          >
            {{ smbl(value, true) }}
          </td>
          <td
            class="pcf-label font-weight-bold"
            style="text-align: center !important"
          >
            {{ summery.amount[value] | currency }}
          </td>
        </tr>
        <tr>
          <!-- <td colspan="3" class="pcf-label font-weight-bold">
            <span>{{$t("risk_category")}}: </span>
            <span>{{exchange.risk_category}}</span>
          </td> -->
          <td colspan="6" class="pcf-label font-weight-bold">
            <span>{{$t("suction_checked")}}: </span>
            <span>{{exchange.suction_checked ? "Yes":"No"}}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <bill-footer :userProp="exchange.user"/>
  </div>
</template>
<script>
import curjs from 'currency.js';
import { customersMixin } from "@/mixins/index.js";
export default {
  name: "bill-exchange",
  mixins: [customersMixin],
  props: {
    exchange: {
      default: () => ({ items: [] }),
    },
    system: { default: () => {} },
  },

  computed: {
    user() {
      return this.$store.getters["AuthModule/current_user"]["user"];
    },
    created() {
      // this.$set(this, "exchange");
    },

    summery() {
      let amount = {};
      let currencies = {};

      this.exchange.items.forEach((item) => {
        // sum exchenges by currency
        if (!amount[item.sale_currency_id]) amount[item.sale_currency_id] = 0;
        amount[item.sale_currency_id] = curjs(amount[item.sale_currency_id]).add(curjs(item.amount)).value;

        if (item.sale_currency_id)
          currencies[item.sale_currency_id] = item.sale_currency_id;
      });
      return { amount, currencies };
    },
  },
};
</script>